module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/book/book.component.css
// module id = ./src/app/components/book/book.component.css
// module chunks = main